
document.addEventListener('click', async (event) => {
  // Open only the clicked size selector.
const toggle = event.target.closest('.card-size-picker__toggle');

if (toggle) {
  // Close all other open size selectors.
  document.querySelectorAll('[data-card-size-picker]').forEach((picker) => {
    if (picker.contains(toggle)) return;

    const panel = picker.querySelector('.card-size-picker__panel');
    const toggleButton = picker.querySelector(
      '.card-size-picker__toggle'
    );
    const addButton = picker.querySelector('.card-size-picker__add');
    const error = picker.querySelector('.card-size-picker__error');

    if (panel && !panel.hidden) {
      panel.hidden = true;

      if (toggleButton) {
        toggleButton.hidden = false;
        toggleButton.setAttribute('aria-expanded', 'false');
      }

      // Clear the previous size selection.
      picker.querySelectorAll('.card-size-picker__size').forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });

      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Add to Cart';
      }

      if (error) {
        error.hidden = true;
      }
    }
  });

  // Open the clicked selector.
  const picker = toggle.closest('[data-card-size-picker]');
  const panel = picker.querySelector('.card-size-picker__panel');

  panel.hidden = false;
  toggle.hidden = true;
  toggle.setAttribute('aria-expanded', 'true');

  return;
}

  // Close size selector and reset selection.
  const close = event.target.closest('.card-size-picker__close');

  if (close) {
    const picker = close.closest('[data-card-size-picker]');
    const panel = picker.querySelector('.card-size-picker__panel');
    const toggleButton = picker.querySelector(
      '.card-size-picker__toggle'
    );
    const addButton = picker.querySelector('.card-size-picker__add');
    const error = picker.querySelector('.card-size-picker__error');

    panel.hidden = true;
    toggleButton.hidden = false;
    toggleButton.setAttribute('aria-expanded', 'false');

    picker.querySelectorAll('.card-size-picker__size').forEach((button) => {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    });

    addButton.disabled = true;
    addButton.textContent = 'Add to Cart';
    error.hidden = true;

    return;
  }

  // Select size.
  const sizeButton = event.target.closest('.card-size-picker__size');

  if (sizeButton && !sizeButton.disabled) {
    const picker = sizeButton.closest('[data-card-size-picker]');
    const addButton = picker.querySelector('.card-size-picker__add');
    const error = picker.querySelector('.card-size-picker__error');

    picker.querySelectorAll('.card-size-picker__size').forEach((button) => {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    });

    sizeButton.classList.add('is-selected');
    sizeButton.setAttribute('aria-pressed', 'true');

    addButton.disabled = false;
    error.hidden = true;

    return;
  }

  // Add selected variant to cart.
  const addButton = event.target.closest('.card-size-picker__add');

  if (!addButton || addButton.disabled) return;

  const picker = addButton.closest('[data-card-size-picker]');
  const selectedSize = picker.querySelector(
    '.card-size-picker__size.is-selected'
  );
  const error = picker.querySelector('.card-size-picker__error');

  if (!selectedSize) return;

  let variants;

  try {
    variants = JSON.parse(picker.dataset.variants);
  } catch {
    error.textContent = 'Unable to load product variants. Please try again.';
    error.hidden = false;
    return;
  }

  const size = selectedSize.dataset.size;
  const sizeOptionIndex = Number(picker.dataset.sizeOptionIndex);

  const variant = variants.find((item) =>
    item.available &&
    item.options?.[sizeOptionIndex] === size
  );

  if (!variant) {
    error.textContent = 'This size is currently unavailable.';
    error.hidden = false;
    return;
  }

  addButton.disabled = true;
  addButton.textContent = 'Adding...';
  error.hidden = true;

  try {
    const response = await fetch(
      `${window.Shopify.routes.root}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: 1 }]
        })
      }
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Unable to add this item.'
      );
    }
    document.querySelector('cart-drawer')?.classList.remove('is-empty');
    addButton.textContent = 'Added!';
    setTimeout(() => {
      addButton.textContent = 'Add to Cart';
    }, 3500);

    // Refresh the Dawn-style cart drawer when available.
    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function') {
      const sections = drawer.getSectionsToRender?.()
        ?.map((section) => section.id)
        ?.filter(Boolean) || ['cart-drawer'];

      const cartResponse = await fetch(
        `${window.Shopify.routes.root}cart.js`
      );

      if (!cartResponse.ok) {
        throw new Error('Item added, but the cart drawer could not refresh.');
      }

      const cart = await cartResponse.json();

      const sectionResponse = await fetch(
        `${window.Shopify.routes.root}?sections=${encodeURIComponent(
          sections.join(',')
        )}`
      );

      if (!sectionResponse.ok) {
        throw new Error('Item added, but the cart drawer could not refresh.');
      }

      const sectionHTML = await sectionResponse.json();

      drawer.renderContents({
        ...cart,
        sections: sectionHTML
      });
    } else {
      // Fallback for themes without a compatible cart drawer.
      window.location.href = `${window.Shopify.routes.root}cart`;
      return;
    }
  } catch (err) {
    error.textContent =
      err.message || 'Something went wrong. Please try again.';
    error.hidden = false;
    addButton.textContent = 'Add to Cart';
  } finally {
    addButton.disabled = false;

    if (addButton.textContent === 'Adding...') {
      addButton.textContent = 'Add to Cart';
    }
  }
});
